// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"af2cf800","406":"94224cac","488":"bd83cf2b","810":"94224cac"}[chunkId] + ".chunk.css";
};